import { ForemanPhaseImport } from './foreman/foreman-job-import.model';
import { ForemanTimeImport } from './foreman/foreman-time-import.model';

export interface ForemanEmployeeImportWeekOption {
  weekStart: Date;
  weekEnd: Date;
  weekKey: string;
  count: number;
  text: string;
}

export interface ForemanEmployeeImportBatch {
  foremanJobID: string;
  jobID: string | null;
  vpJobID: string;
  name: string;
  displayName: string;
  companyID: string | null;
  vpCompanyID: number | null;
  date: Date;
  unmappedWorkOrders: ForemanPhaseImport[];
  records: ForemanTimeImport[];
}
